import { render } from "./UploadImageNew.vue?vue&type=template&id=54be1d4b&scoped=true"
import script from "./UploadImageNew.vue?vue&type=script&lang=js"
export * from "./UploadImageNew.vue?vue&type=script&lang=js"

import "./UploadImageNew.vue?vue&type=style&index=0&id=54be1d4b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54be1d4b"]])

export default __exports__